// External libraries
import gql from 'graphql-tag';
//internal modules
import {
  CART_FRAGMENT,
  COMPLETED_PAYMENT_INFO_FRAGMENT,
} from '@/lib/graphql/fragments';
import {
  THREE_DOMAIN_SECURE_FRAGMENT,
  THREE_DS_2_CONTINGENCY_FRAGMENT,
} from '../fragments';

export const APPROVE_ONBOARD_PAYMENT_MUTATION = gql`
  mutation ApproveOnboardPaymentMutation(
    $token: String!
    $instrumentId: String
    $isBillingAgreement: Boolean!
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
  ) {
    attemptSetStickyFi(token: $token, instrumentId: $instrumentId)
      @include(if: $isBillingAgreement) {
      buyer {
        userId
      }
    }
    approveGuestSignUpPayment(token: $token) {
      buyer {
        userId
        email {
          stringValue
        }
        name {
          fullName
        }
      }
      ...CartDonePage
      ...CompletedPaymentInfo
      fundingOptions {
        fundingInstrument {
          id
          lastDigits
          name
          nameDescription
          type
        }
      }
      merchant {
        name
        preferences {
          autoReturnToMerchant
          enablePaymentDataTransfer
          returnUrl
        }
      }
      shippingAddresses {
        fullAddress
        name {
          fullName
        }
      }
      paymentContingencies {
        ...threeDomainSecure
        ...threeDSContingencyData
      }
    }
  }
  ${CART_FRAGMENT}
  ${COMPLETED_PAYMENT_INFO_FRAGMENT}
  ${THREE_DOMAIN_SECURE_FRAGMENT}
  ${THREE_DS_2_CONTINGENCY_FRAGMENT}
`;
